// extracted by mini-css-extract-plugin
export default {"background":"CollageGallery_background__QqWG1","container":"CollageGallery_container__zriBE","title":"CollageGallery_title__uGvwM","imgWrapper":"CollageGallery_imgWrapper__V51N-"};